import { useState } from "react";
import { buildCitation, type AccessReportIssue } from "@/lib/access-report";

export function CiteBlock({
  issue,
}: {
  issue: Pick<AccessReportIssue, "issueNo" | "slug" | "period">;
}) {
  const [copyState, setCopyState] = useState<"idle" | "copied" | "failed">("idle");
  const citation = buildCitation(issue);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(citation);
      setCopyState("copied");
      window.setTimeout(() => setCopyState("idle"), 2_500);
    } catch {
      setCopyState("failed");
    }
  };

  return (
    <aside className="pb-access-cite" aria-labelledby="access-cite-heading">
      <div>
        <p className="pb-access-eyebrow">Open data</p>
        <h2 id="access-cite-heading">Cite this report</h2>
      </div>
      <p>{citation}</p>
      <div className="pb-access-cite__actions">
        <button type="button" onClick={() => void copy()}>
          {copyState === "copied" ? "Copied" : "Copy citation"}
        </button>
        <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener">
          CC BY 4.0
        </a>
        {copyState === "failed" ? <span role="alert">Copy failed — select the citation above.</span> : null}
      </div>
    </aside>
  );
}
